/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { EventLogEntry, EventLogEntry$inboundSchema } from "./eventlogentry.js";

/**
 * Result of listing org-scoped OpenTelemetry events
 */
export type ListEventLogResult = {
  /**
   * Events ordered newest first
   */
  events: Array<EventLogEntry>;
  /**
   * Cursor for next page
   */
  nextCursor?: string | undefined;
  /**
   * Number of events matching the filters, capped at 10000
   */
  totalCount: number;
  /**
   * True when total_count hit the cap and the true count is higher
   */
  totalCountCapped: boolean;
};

/** @internal */
export const ListEventLogResult$inboundSchema: z.ZodMiniType<
  ListEventLogResult,
  unknown
> = z.pipe(
  z.object({
    events: z.array(EventLogEntry$inboundSchema),
    next_cursor: z.optional(z.string()),
    total_count: z.int(),
    total_count_capped: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
      "total_count": "totalCount",
      "total_count_capped": "totalCountCapped",
    });
  }),
);

export function listEventLogResultFromJSON(
  jsonString: string,
): SafeParseResult<ListEventLogResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEventLogResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEventLogResult' from JSON`,
  );
}
